const BASE_URL = `${process.env.REACT_APP_API_PERMITS_BASE_URL}/ContractCode`;

// items: Array of { code: string, phoneNumber: string | null, registrationPlate: string | null }
// Returnerar per-rad-resultat + summary baserat på systemdata — utan att skriva till DB.
export const previewContractCodes = async (token, parkingAreaExtId, items) => {
  const response = await fetch(BASE_URL + '/preview', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      parkingAreaExtId,
      items
    })
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

// items: Array of { code: string, phoneNumber: string | null }
export const uploadContractCodes = async (token, parkingAreaExtId, items) => {
  const response = await fetch(BASE_URL + '/upload', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      parkingAreaExtId,
      items
    })
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const getContractCodes = async (token, parkingAreaExtId, includeInactive = false) => {
  const url = includeInactive
    ? BASE_URL + `/list/${parkingAreaExtId}?includeInactive=true`
    : BASE_URL + `/list/${parkingAreaExtId}`;

  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const lookupContractCode = async (token, parkingAreaExtId, code) => {
  const response = await fetch(BASE_URL + `/lookup/${parkingAreaExtId}/${encodeURIComponent(code)}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    return response.json();
  }

  if (response.status === 404) {
    return null;
  }

  throw response;
};

export const resetContractCode = async (token, contractCodeId) => {
  const response = await fetch(BASE_URL + `/reset/${contractCodeId}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    const responseBody = await response.text();
    if (!responseBody) {
      return {};
    } else {
      return JSON.parse(responseBody);
    }
  }

  throw response;
};

export const revokeContractCode = async (token, contractCodeId) => {
  const response = await fetch(BASE_URL + `/revoke/${contractCodeId}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    const responseBody = await response.text();
    if (!responseBody) {
      return {};
    } else {
      return JSON.parse(responseBody);
    }
  }

  throw response;
};

export const getAvailablePermitsForIssue = async (token, parkingAreaExtId) => {
  const response = await fetch(BASE_URL + `/available-permits/${parkingAreaExtId}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

// 2.10 C3: Paginerad + sökbar variant för 400+ platser
export const getAvailablePermitsForIssuePaged = async (token, parkingAreaExtId, page = 1, pageSize = 50, query = '') => {
  const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
  if (query) params.append('query', query);
  const response = await fetch(BASE_URL + `/available-permits-paged/${parkingAreaExtId}?${params.toString()}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const issuePermitWithCode = async (token, contractCodeId, phoneNumber, registrationPlate, permitExtId) => {
  const response = await fetch(BASE_URL + '/issue', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      contractCodeId,
      phoneNumber,
      registrationPlate,
      ...(permitExtId && { permitExtId })
    })
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const deleteContractCode = async (token, contractCodeId) => {
  const response = await fetch(BASE_URL + `/delete/${contractCodeId}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    const responseBody = await response.text();
    if (!responseBody) {
      return {};
    } else {
      return JSON.parse(responseBody);
    }
  }

  throw response;
};

export const getVehiclesForPhone = async (token, phoneNumber) => {
  const response = await fetch(BASE_URL + `/vehicles-for-phone/${encodeURIComponent(phoneNumber)}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const createVehicleForPhone = async (token, phoneNumber, registrationPlate) => {
  const response = await fetch(BASE_URL + '/create-vehicle-for-phone', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      phoneNumber,
      registrationPlate
    })
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const scheduleTransition = async (token, contractCodeId, phoneNumber, activeDate, vehicleId) => {
  const response = await fetch(BASE_URL + '/schedule-transition', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    },
    body: JSON.stringify({
      contractCodeId,
      phoneNumber,
      activeDate,
      ...(vehicleId && { vehicleId })
    })
  });

  if (response.status === 200) {
    return response.json();
  }

  throw response;
};

export const cancelTransition = async (token, contractCodeId) => {
  const response = await fetch(BASE_URL + `/cancel-transition/${contractCodeId}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    const responseBody = await response.text();
    if (!responseBody) {
      return {};
    } else {
      return JSON.parse(responseBody);
    }
  }

  throw response;
};

export const reactivateContractCode = async (token, contractCodeId) => {
  const response = await fetch(BASE_URL + `/reactivate/${contractCodeId}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`
    }
  });

  if (response.status === 200) {
    const responseBody = await response.text();
    if (!responseBody) {
      return {};
    } else {
      return JSON.parse(responseBody);
    }
  }

  throw response;
};
